import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';
import {EventType} from 'src/openapi/models/EventType';

export const DEFAULT_EVENT_CREATION_INFO = {
    id: 0,
    code: '',
    description: '',
    trigger: '',
    source: '',
    type: '' as EventType,
    families: [] as Array<string>,
    attributes: [] as Array<AttributeChangeRequest>,
    reported: false,
    decorated: false,
    deprecated: false,
};

export enum EventCreationMode {
    create = 'create',
    update = 'update',
}

export const EVENT_MODE_TITLE = {
    [EventCreationMode.create]: 'Creation',
    [EventCreationMode.update]: 'Update',
};

export enum HeaderFields {
    eventType = 'type',
    eventCode = 'code',
    eventSource = 'source',
    eventDescription = 'description',
    families = 'families',
    trigger = 'trigger',
    reported = 'reported',
    decorated = 'decorated',
    deprecated = 'deprecated',
}

export const FIELDS_PATTERN = {
    name: /\W/g,
    attributeName: /[^a-zA-Z_]/g,
    description: /[^0-9 A-Za-z-.&(–—)+,:"'/]/g,
    trigger: /[^0-9 A-Za-z-.&(–—)+,:"'\n/]/g,
};

export enum PushNotificationIds {
    sendToReviewFailure = 'sendToReviewFailure',
    sendToReviewSuccess = 'sendToReviewSuccess',
    saveChangeRequestFailure = 'saveChangeRequestFailure',
    saveChangeRequestSuccess = 'saveChangeRequestSuccess',
    updateChangeRequestFailure = 'updateChangeRequestFailure',
    updateChangeRequestSuccess = 'updateChangeRequestSuccess',
    notSavedChangeRequest = 'notSavedChangeRequest',
    changeRequestAnotherAuthor = 'changeRequestAnotherAuthor',
    existingEventCode = 'existingEventCode',
    uploadTriggerAttachmentFailure = 'uploadTriggerAttachmentFailure',
    maxTriggerAttachment = 'maxTriggerAttachment',
}

export const ATTRIBUTE_EVENT_CODE = 'event_code';
export const ATTRIBUTE_EVENT_SOURCE = 'event_source';
export const ATTRIBUTE_EVENT_DATE = 'event_date';
export const REQUIRED_ATTRIBUTES = [ATTRIBUTE_EVENT_CODE, ATTRIBUTE_EVENT_SOURCE, ATTRIBUTE_EVENT_DATE];
export const FIELDS_PATTERN_VALIDATION_MESSAGE =
    'Only Latin characters, numbers and / & ( – — ) + , . : " \' - symbols are allowed.';
